export default __webpack_public_path__ + "images/9e05d825c150415c2e906a06228dc34d.png";